import {Injectable} from '@angular/core';
import {MatDialog, MatDialogRef} from '@angular/material/dialog';
import {ConfirmationDialogComponent} from './confirmation-dialog.component';
import {ConfirmationDialogData} from './confirmation-dialog-data';

@Injectable({
  providedIn: 'root'
})
export class ConfirmationDialogService {

  constructor(private dialog: MatDialog) {}

  openConfirmationDialog(data: ConfirmationDialogData): MatDialogRef<ConfirmationDialogComponent> {
    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      data: data,
    });

    return dialogRef;
  }
}
